import React from "react";
import Dialog from "@mui/material/Dialog";
import Box from "@mui/material/Box";
import AddItems2 from "../AddItems2";

const AddItems2Dialog = ({ open, onClose, refresh }) => {
  const handleRefresh = () => {
    if (refresh) refresh();
    onClose();
  };
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{ sx: { backgroundImage: "none" } }}
    >
      <Box
        sx={{
          "& .add-media-card": {
            boxShadow: "none !important",
            border: "none !important",
            background: "transparent !important",
          },
        }}
      >
        <AddItems2 refresh={handleRefresh} />
      </Box>
    </Dialog>
  );
};

export default AddItems2Dialog;
